// src/components/RegistroExitoso.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

export default function RegistroExitoso() {
  const nav = useNavigate();
  return (
    <div className="registro-exitoso-page">
      <div className="registro-card">
        <div className="icon">
          <i className="bi bi-shield-check"></i>
        </div>
        <h1>¡Cuenta creada!</h1>
        <p>
          Tu invitación se completó correctamente. Ya puedes cerrar esta ventana.
        </p>
        <button
          className="btn-primary"
          onClick={() => nav("/")}
        >
          Continuar
        </button>
      </div>
    </div>
  );
}
